import { CoachStatus, CoachSubStatus, CoachSubStatusLabelMap } from '@airreading/common/data';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card.js';
import { getCoachStatusColor, getCoachStatusLabel } from '@/lib/coach-utils.js';

interface StatusInfoProps {
  label: string;
  color: string;
  className?: string | string[];
}

export const StatusInfo = ({ label, color, className }: StatusInfoProps) => (
  <span className="inline-flex items-center gap-2">
    <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: color }} />
    <span style={{ color }} className={Array.isArray(className) ? className.join(' ') : className}>
      {label}
    </span>
  </span>
);

interface CoachStatusCellProps {
  status: CoachStatus | null | undefined;
  subStatuses?: CoachSubStatus[] | null;
}

export const CoachStatusCell = ({ status, subStatuses }: CoachStatusCellProps) => {
  const color = getCoachStatusColor(status);
  const statusLabel = getCoachStatusLabel(status);

  if (subStatuses && subStatuses.length > 0) {
    const labels = subStatuses.map((s) => CoachSubStatusLabelMap[s as CoachSubStatus]);

    if (labels.length === 1) {
      return <StatusInfo label={`${statusLabel} - ${labels[0]}`} color={color} />;
    }

    return (
      <HoverCard>
        <HoverCardTrigger asChild>
          <span className="cursor-pointer">
            <StatusInfo label={`${statusLabel} - ${labels[0]}...`} color={color} className="underline" />
          </span>
        </HoverCardTrigger>
        <HoverCardContent className="w-auto p-4">
          <ul className="space-y-2">
            {labels.map((label) => (
              <li key={`${status}-${label}`} className="text-sm">
                <StatusInfo label={`${statusLabel} - ${label}`} color={color} />
              </li>
            ))}
          </ul>
        </HoverCardContent>
      </HoverCard>
    );
  }

  return <StatusInfo label={statusLabel} color={color} />;
};
